import { getMessageFromApi, Message, MessageFromApi } from '@/models/Message';
import { LatestUIState } from '@/store/Selectors/UIStateBuilder';
import { Reaction } from '@/models/Reaction';
import { UserFromApi } from '@/models/User';
import { WidgetData } from '@/models/PanelWidgets';

export type ThreadId = string;

export type Thread = {
  id: ThreadId;
  name: string;
  messages: Message[];
  participantUserIds: string[];
  uiState: LatestUIState | null;
  viewerReaction?: Reaction | null;
};

export type NewThread = Omit<Thread, 'id'>;

export type ThreadFromApi = {
  key: string;
  name: string;
  users: UserFromApi[];
  messages: MessageFromApi[];
  ui_state: {
    widgets_in_view: WidgetData[];
  } | null;
  viewer_reaction?: string | null;
};

export type HandlerProfileFromApi = {
  name: string;
  description: string;
};

export function getThreadFromApi(args: ThreadFromApi): Thread {
  const viewerReaction =
    args.viewer_reaction &&
    Object.values(Reaction).includes(args.viewer_reaction as Reaction)
      ? (args.viewer_reaction as Reaction)
      : null;
  return {
    id: args.key,
    name: args.name,
    messages: args.messages.map((message) =>
      getMessageFromApi(args.key, message),
    ),
    participantUserIds: args.users.map((user) => user.uuid),
    uiState: args.ui_state
      ? {
          widgetsInView: args.ui_state.widgets_in_view,
        }
      : null,
    viewerReaction,
  };
}
